import Content from "../component/Content"




const About = () => {


    return (
        <div>
            <Content
                center={
                    <div>
                        <h1>Impressum</h1>
                
                        <p>Eike Freiwald <br/>
                        Bachgauweg 7 <br/>
                        64291 Darmstadt</p>
                
                        <h2>Kontakt</h2>
                        <p>E-Mail: support@freike.de</p>
                    </div>
                }
            />
        </div>
    )
}

export default About